import { Modal, Typography, Button } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { getModalStyle, useStyles } from "Theme/styles";

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 12px 6px;
  justify-content: space-between;
`;

interface StandardModalProps {
  title: string;
  description?: string;
  cancellable?: boolean;
  open: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
  children: React.ReactNode;
  submitText?: string;
}
export default function StandardModal({
  open,
  title,
  description,
  cancellable = false,
  onCancel,
  onSubmit,
  children,
  submitText = "Submit",
}: StandardModalProps) {
  const classes = useStyles();
  let descriptionComp;
  if (!!description) {
    descriptionComp = <Typography>{description}</Typography>;
  }
  return (
    <Modal
      open={open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div style={getModalStyle()} className={classes.paper}>
        <Typography variant="h5">{title}</Typography>
        {descriptionComp}
        {children}
        <ButtonsContainer>
          <Button variant="contained" color="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            {submitText}
          </Button>
        </ButtonsContainer>
      </div>
    </Modal>
  );
}
